// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import SelectInput from 'common/components/Select/SelectInput';

export const StyledSelector = styled(SelectInput)``;
